import { createFileRoute } from '@tanstack/react-router';

import { ClientAssessmentResultScreen } from '@/features/assessments/components/client/ClientAssessmentResultScreen';

export const Route = createFileRoute('/client/assessments/$assessmentId/$assignmentId/result')({
  component: ClientAssessmentResultRoute,
});

function ClientAssessmentResultRoute() {
  const { assessmentId, assignmentId } = Route.useParams();
  return <ClientAssessmentResultScreen assessmentId={assessmentId} assignmentId={assignmentId} />;
}
